import React from 'react';
import { useValue } from './react';
export var isActionKey = function isActionKey(event) {
  return event.key === 'Enter' || event.key === ' ';
}; // Some elements automatically trigger a click event on `keyup` events,
// so combine `keyDownAsClick` with `onKeyUp={preventAction}` to stop duplicate clicks.

export var preventAction = function preventAction(event) {
  if (isActionKey(event)) {
    event.preventDefault();
  }
};
export var keyDownAsClick = function keyDownAsClick(event) {
  if (isActionKey(event)) {
    event.preventDefault();
    var target = event.target;
    target.click && target.click();
  }
};
export var LiveRegion = function LiveRegion(inProps) {
  var value = inProps.value,
      changeKey = inProps.changeKey,
      _inProps$live = inProps.live,
      live = _inProps$live === void 0 ? 'polite' : _inProps$live,
      _inProps$visible = inProps.visible,
      visible = _inProps$visible === void 0 ? false : _inProps$visible;
  var style = visible ? undefined : INVISIBLE;
  var props = {
    'aria-live': live,
    style: style
  };
  var contents = useValue(value, [changeKey]);
  return /*#__PURE__*/React.createElement('div', props, contents);
};
var INVISIBLE = {
  position: 'absolute',
  transform: 'scale(0)',
  zIndex: '-1'
};